module.exports = __webpack_public_path__ + "static/media/nymag.com_daily_intelligencer_2016_04_america-tyranny-donald-trump.html_plot.52bb0372.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/nymag.com_daily_intelligencer_2016_04_america-tyranny-donald-trump.html_plot.png
// module id = 401
// module chunks = 0